<template>
  <BaseVeeForm
    :action="activateUser"
    ensure-error-keys-camel-case
    v-slot="formProps"
    class="space-y-2"
  >
    <div class="space-y-4">
      <ValidationProvider name="user" slim vid="user">
        <template #default="{ errors }">
          <BaseFormGroup>
            <div>
              <BaseFormInput type="hidden" :value="user.id" />
            </div>
            <BaseFormInlineMessage v-if="errors.length" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
    </div>
    <div>
      <button
        role="button"
        class="inline-block text-blue-600 focus:text-blue-600 hover:text-blue-600 font-medium whitespace-nowrap text-sm border rounded px-4 py-1.5 hover:border-blue-600"
        :disabled="formProps.invalid || formProps.isPending"
      >
        {{ user.activationEmailExpiresAt ? 'Resend Activation' : 'Activate' }}
      </button>
      <div v-if="hasSentActivationEmail" class="text-xs mt-1">
        <span v-if="minutesRemaining">
          Email activation expires in {{ minutesRemaining }} minutes
        </span>
        <span v-else>Email activation has expired</span>
      </div>
    </div>
  </BaseVeeForm>
</template>

<script>
import moment from 'moment';
import { activatedUsersApi } from '@/api/clients/admin';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasSentActivationEmail() {
      return typeof this.user?.activationEmailExpiresAt === 'string';
    },
    minutesRemaining() {
      if (!this.hasSentActivationEmail) {
        return 0;
      }

      const expiresAt = moment(this.user?.activationEmailExpiresAt).utc().local();
      const now = moment();
      const diff = expiresAt.diff(now, 'minutes');
      return diff > 0 ? diff : 0;
    },
  },
  methods: {
    async activateUser() {
      try {
        await activatedUsersApi.store(
          mapKeysToSnakeCase({
            user: this.user.id,
            activationUrl: `${process.env.VUE_APP_URL}/activate/user`,
          })
        );

        this.$emit('activated');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
